import React from 'react';
import { MailIcon, MessageSquareIcon, ClockIcon, HelpCircleIcon } from 'lucide-react';
export function SupportContent() {
  return <div className="space-y-6" data-id="element-1220">
      <p className="text-gray-700 mb-6" data-id="element-1221">
        Estamos aquí para ayudarte con cualquier pregunta o problema que tengas
        con nuestro producto. Elige la opción que mejor se adapte a tu
        necesidad:
      </p>

      {/* Contact Options */}
      <div className="grid md:grid-cols-2 gap-4" data-id="element-1222">
        {/* Email Support */}
        <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1223">
          <div className="flex items-center gap-3 mb-4" data-id="element-1224">
            <div className="w-12 h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center" data-id="element-1225">
              <MailIcon className="w-6 h-6 text-white" data-id="element-1226" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1227">
              Email de Soporte
            </h3>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-1228">
            Envíanos un email y te responderemos en menos de 24 horas.
          </p>
          <a href="mailto:contactomikioscodigital@gmail.com" className="inline-flex items-center gap-2 text-baby-blue-dark hover:text-baby-blue font-bold transition" data-id="element-1229">
            <MailIcon className="w-4 h-4" data-id="element-1230" />
            contactomikioscodigital@gmail.com
          </a>
        </div>

        {/* Contact Form */}
        <div className="bg-gradient-to-br from-baby-pink-light to-baby-blue-light p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1231">
          <div className="flex items-center gap-3 mb-4" data-id="element-1232">
            <div className="w-12 h-12 bg-baby-gradient-pink rounded-full flex items-center justify-center" data-id="element-1233">
              <MessageSquareIcon className="w-6 h-6 text-white" data-id="element-1234" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1235">
              Formulario de Contacto
            </h3>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-1236">
            Usa nuestro formulario de contacto para enviarnos tu consulta
            detallada.
          </p>
          <p className="text-baby-pink-dark font-bold" data-id="element-1237">
            Disponible en el footer → Contacto
          </p>
        </div>
      </div>

      {/* Support Hours */}
      <div className="bg-baby-cream p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1238">
        <div className="flex items-center gap-3 mb-4" data-id="element-1239">
          <ClockIcon className="w-6 h-6 text-baby-blue" data-id="element-1240" />
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1241">
            Horario de Atención
          </h3>
        </div>
        <div className="space-y-2 text-gray-700" data-id="element-1242">
          <p data-id="element-1243">
            <strong data-id="element-1244">Lunes a Viernes:</strong> 9:00 AM - 6:00 PM (GMT-5)
          </p>
          <p data-id="element-1245">
            <strong data-id="element-1246">Sábados:</strong> 10:00 AM - 2:00 PM (GMT-5)
          </p>
          <p data-id="element-1247">
            <strong data-id="element-1248">Domingos:</strong> Cerrado
          </p>
          <p className="text-sm text-gray-600 mt-3" data-id="element-1249">
            * Los emails recibidos fuera del horario serán respondidos el
            siguiente día hábil
          </p>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white p-6 rounded-baby-lg border-2 border-baby-blue-light" data-id="element-1250">
        <div className="flex items-center gap-3 mb-4" data-id="element-1251">
          <HelpCircleIcon className="w-6 h-6 text-baby-blue" data-id="element-1252" />
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1253">
            Preguntas Frecuentes
          </h3>
        </div>
        <div className="space-y-4" data-id="element-1254">
          <div data-id="element-1255">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1256">
              ¿Cómo descargo mi producto?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1257">
              Después de completar tu compra, recibirás un email con el link de
              descarga. Revisa tu bandeja de spam si no lo encuentras.
            </p>
          </div>
          <div data-id="element-1258">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1259">
              ¿Puedo solicitar un reembolso?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1260">
              Sí, ofrecemos garantía de 30 días. Contáctanos a{' '}
              <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1261">
                contactomikioscodigital@gmail.com
              </a>{' '}
              con tu número de orden.
            </p>
          </div>
          <div data-id="element-1262">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1263">
              ¿El producto está en español?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1264">
              Sí, todo el contenido está 100% en español, adaptado para LATAM.
            </p>
          </div>
          <div data-id="element-1265">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1266">
              ¿Necesito conocimientos previos?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1267">
              No, las recetas están diseñadas para mamás primerizas sin
              experiencia culinaria.
            </p>
          </div>
        </div>
      </div>

      {/* Response Time */}
      <div className="bg-gradient-to-r from-baby-blue-light to-baby-pink-light p-4 rounded-baby text-center border-2 border-baby-lavender" data-id="element-1268">
        <p className="text-gray-900 font-bold" data-id="element-1269">
          ⏱️ Tiempo promedio de respuesta:{' '}
          <span className="text-baby-blue-dark" data-id="element-1270">Menos de 24 horas</span>
        </p>
      </div>
    </div>;
}